import { GET_EXCLUSIVITY_BANNER } from 'constants/exclusivity-banner';

const initialState = {
  isFetching: false,
  data: {},
  error: null,
};

export const exclusivityBannerReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case `${GET_EXCLUSIVITY_BANNER}_PENDING`: {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    }
    case `${GET_EXCLUSIVITY_BANNER}_FULFILLED`: {
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    }
    case `${GET_EXCLUSIVITY_BANNER}_REJECTED`: {
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
